module.exports = __webpack_public_path__ + "static/media/hungryJacks.c40e8c1e.webp";